module.exports = __webpack_public_path__ + "img/icon-2.763157b5.png";